// extracted by mini-css-extract-plugin
export default {"text":"vacancies-drop-down_text__zbHs-","input":"vacancies-drop-down_input__5X3jE","placeholder":"vacancies-drop-down_placeholder__wxXUN"};